import React from "react";
import appointment from "../../../../assets/dashboard/appointment.jpg";
import {
  baseURLImage,
  getNameProfile,
  formatDateToAustralian,
} from "Utils/utils";

const AppointmentCard = ({ item }) => {
  const backgroundImageStyle = {
    backgroundImage: `url(${appointment})`,
    backgroundSize: "cover",
    backgroundRepeat: "no-repeat",
  };

  const isToday = (date) => {
    const today = new Date();
    return (
      date.getDate() === today.getDate() && date.getMonth() === today.getMonth()
    );
  };

  const appointmentDate = new Date(item?.date);
  const UpcomingAppointment = isToday(appointmentDate);

  const handleImageError = (e, fname, lname) => {
    return (e.target.src = getNameProfile(fname, lname));
  };

  return (
    <div className="bg-gradient-to-br from-green-50 via-emerald-50 to-green-100 border border-green-200 rounded-lg p-3 sm:p-4 hover:shadow-md transition-all duration-200 group">
      <div className='flex items-start gap-2 sm:gap-3'>
        <div className='relative h-10 w-10 sm:h-12 sm:w-12 flex-shrink-0'>
          <img
            onError={(e) => handleImageError(e, item?.participant_name, item?.participant_name)}
            className='object-cover h-10 w-10 sm:h-12 sm:w-12 rounded-full ring-2 ring-green-300 group-hover:ring-green-400 transition-all'
            src={
              item?.photo
                ? baseURLImage(item?.photo)
                : getNameProfile(item.participant_name, item?.participant_name || " ")
            }
            alt=''
          />
          {UpcomingAppointment && (
            <div className="absolute -top-1 -right-1 h-3 w-3 sm:h-4 sm:w-4 bg-green-500 rounded-full border-2 border-white animate-pulse"></div>
          )}
        </div>
        <div className='flex-1 min-w-0'>
          <div className='font-semibold text-xs sm:text-sm text-gray-900 capitalize truncate'>
            {item?.participant_name}
          </div>
          <div className='text-[10px] sm:text-xs font-medium text-gray-700 mt-1 truncate'>
            {item?.title}
          </div>
          <div className={`text-[10px] sm:text-xs font-medium mt-1.5 sm:mt-2 ${UpcomingAppointment ? 'text-green-600' : 'text-gray-600'}`}>
            {UpcomingAppointment ? (
              <span className="flex items-center gap-1">
                <span className="inline-block w-1.5 h-1.5 sm:w-2 sm:h-2 bg-green-500 rounded-full animate-pulse"></span>
                <span className="truncate">Today at {item?.time}</span>
              </span>
            ) : (
              <span className="truncate">{formatDateToAustralian(item?.date)} at {item?.time}</span>
            )}
          </div>
          {item?.assignedWorkers && item.assignedWorkers.length > 0 && (
            <div className='text-[10px] sm:text-xs text-gray-600 mt-1 truncate'>
              Worker: {item.assignedWorkers.map((worker) => worker.label).join(", ")}
            </div>
          )}
          {item?.location && (
            <div className='text-[10px] sm:text-xs text-gray-500 mt-1 truncate' title={item?.location}>
              📍 {item?.location}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default AppointmentCard;
